import { Navigate } from 'react-router-dom';
import { ReactNode, Suspense } from 'react';
import Loader from '../../../components/loader';
import { getUserRole } from '../../../service/auth';
import { Roles } from '../../../utils/enums';

const ProtectedRoute = ({ children }:{children:ReactNode}) => {
  const userRole = getUserRole();

  if (userRole == Roles.ADMIN) {
    
    return <Suspense fallback={<Loader />}>{children}</Suspense>;
  }

  return <Navigate to="/dashboard/questionnarie/main" />;
};



export default ProtectedRoute;